import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  imports: [ModalModule.forRoot()],
  exports: [ModalModule],
})
export class NgxBootstrapModulesModule {}
